import React, { useContext, useMemo, useRef } from 'react';
import { UNSAFE_LocationContext as LocationContext, UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const noop = () => undefined;

/**
 * 画面の切り替えでは、前の画面が消えるまでの動きの間、前の画面も新しい URL で描き直される（V2Layout の AnimatePresence）。
 * そのままだと前の画面が「?product が無くなった」と見て URL を書き換え、移動先の #... が消える。
 * 画面の外へ出たあとは、前の画面にはもとの場所を見せ続け、URL を変えさせない。
 */
export const OwnLocation: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigation = useContext(NavigationContext);
  const current = useContext(LocationContext);
  const own = useRef(current);
  const left = current.location.pathname !== own.current.location.pathname;
  if (!left) own.current = current;
  const nav = useMemo(
    () =>
      left
        ? {
            ...navigation,
            navigator: { ...navigation.navigator, push: noop, replace: noop },
          }
        : navigation,
    [left, navigation],
  );
  return (
    <NavigationContext.Provider value={nav}>
      <LocationContext.Provider value={own.current}>{children}</LocationContext.Provider>
    </NavigationContext.Provider>
  );
};
